<template>
	<div class="reply-extend">
		<div class="reply-extend-opt">
			<div class="reply-extend-opt-item" v-for="group in groupList">
				<button @click="getReply(group.id,1)" :title="'发送连接消息：'+group.title">{{group.title}}</button>
				<button class="reply-extend-send-img" @click="getReply(group.id,2)" :title="'发送图片消息：'+group.title">{{group.title}}</button>
			</div>
		</div>
		<div class="reply-extend-history">
			<div class="reply-extend-history-wrap">
				<div v-for="history in historyList">
					<div class="reply-extend-link reply-extend-item" v-if="history.type == 1">
						<div class="reply-extend-link-title">
							<p>{{history.content.link_title}}</p>
						</div>
						<div class="reply-extend-link-info">
							<p>{{history.content.link_desc}}</p> 
							<img :src="history.content.link_img">
						</div>
						<div class="reply-extend-link-tip">
							<p style="color: #db6f00;">{{history.g_title}}-{{history.extra_title}}</p>
						</div>
						<div class="reply-extend-link-tip reply-extend-link-tip-noborder"> 
							<img src="/img/link-big-8a.png">
							<p>普通链接</p>
						</div>
						<div class="reply-extend-link-tip reply-extend-link-tip-noborder">
							<img src="/img/time-icon.png">
							<p>{{history.create_time}}</p>
						</div>
					</div>
					<div class="reply-extend-img reply-extend-item" v-else>
						<div class="reply-extend-img-box">
							<img :src="history.content.url" alt="">
						</div>
						<div class="reply-extend-img-tip">
							<img src="/img/tips-icon.png">
							<p>
								<span>{{history.wx_name}}--{{history.identity}}--{{history.manager_name}}（</span>
								<span v-if="history.pass_status == 0">待通过</span>
								<span class="reply-extend-img-pass" v-else>已通过</span>
								<span>）</span>
							</p>
						</div>
						<div class="reply-extend-img-tip" style="border-top: none;">
							<img src="/img/time-icon.png">
							<p>{{history.create_time}}</p>
						</div>
					</div>
				</div>
				<div class="reply-extend-count">
					<p v-if="historyList.length > 0">共{{historyList.length}}条记录！</p>
					<p v-else>暂无发送记录！</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getQuicklyTechHistory,getQuicklyTech,getQuicklyTechGG} from '../../../network/web/quickly-reply.js'
	import {sendMsg} from '../../../socket/socketSender.js'
	export default {
		name: 'ChatInfoReplyExtend',
		props:{
			  chatting:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			  }
		},
		data() {
			return {
				historyList:[],
				groupList:[]
			}
		},
		methods:{
			// 获取智能快捷语分组按钮
			getReplyGG(){
				getQuicklyTechGG(data=>{
					if(data.code != 1){
						return
					}
					this.groupList = data.data
				})
			},
			
			// 获取当前可以与粉丝的智能快捷语发送历史
			getHistory(){
				this.historyList = []
				if(this.chatting.chat_type === undefined || this.chatting.chat_type != 1){
					return
				}
				let custom_wxid = this.chatting.account_open_id
				let fans_id = this.chatting.friend_or_cluster_id
				getQuicklyTechHistory(custom_wxid,fans_id,data=>{
					if(data.code != 1){
						return
					}
					let temp = [];
					for (let i = 0; i < data.data.length; i++) {
						if(data.data[i].type === null){
							continue
						}
						data.data[i].content = JSON.parse(data.data[i].content)
						temp.push(data.data[i])
					}
					this.historyList = temp
				})
			},
			
			// 获取智能快捷语
			getReply(group_id,type){
				if(this.chatting.chat_type === undefined || this.chatting.chat_type != 1){
					return
				}
				let custom_wxid = this.chatting.account_open_id
				let fans_id = this.chatting.friend_or_cluster_id
				let fans_wxid = this.chatting.friends_open_id
				getQuicklyTech(custom_wxid,fans_id,fans_wxid,type,group_id,data=>{
					if(data.code == 0){
						CHAT_LAYER.msg(data.msg,{icon:2})
						return
					}
					let s_data = data.data
					// 添加上额外参数，用于数据回调
					if(s_data.content !== undefined && s_data.content.link_url !== undefined){
						let link_url = s_data.content.link_url
						if(link_url.indexOf('?') === -1){
							link_url += '?'
						}else{
							link_url += '&'
						}
						link_url += 'userTraceId=gw_'+s_data.chat_custom_id+'_'+s_data.chat_fans_id
						s_data.content.link_url = link_url
					}
					this.historyList.unshift(s_data)
					this.sendToUser(s_data)
				})
			},
			
			// 发送消息
			sendToUser(data) {
				if(data.type === undefined){
					CHAT_LAYER.msg('数据格式异常', {
						icon: 2
					})
					return
				}
				if(data.type == 1){
					if(data.content.link_img !== undefined && data.content.link_img != ''){
						data.content.link_img = data.content.link_img+'?x-oss-process=style/thumb_90'
					}
					sendMsg(this.$store.state.chatFans, JSON.stringify(data.content), 'link', this)
				}else if(data.type == 2){
					sendMsg(this.$store.state.chatFans, data.content.url, 'image', this)
				}
				CHAT_LAYER.msg('操作成功', {
					icon: 1
				})
			},
		},
		watch:{
			chatting(){
				this.getHistory()
				this.getReplyGG()
			}
		},
		created() {
			this.getHistory()
			this.getReplyGG()
		}
	}
</script>

<style>
	.reply-extend {
		width: 100%;
		position: absolute;
		top: 40px;
		bottom: 0;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
	}

	.reply-extend-opt {
		/* max-height: 106px; */
		overflow-x: hidden;
		overflow-y: auto;
	}
	.reply-extend-opt-item{
		padding: 10px 10px;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
	.reply-extend-opt-item>button {
		width: 100px;
		line-height: 26px;
		height: 26px;
		border-radius: 4px;
		background-color: #2bad37;
		color: #FFFFFF;
		cursor: pointer;
		font-size: 12px;
		overflow: hidden;
	}

	.reply-extend-opt-item>.reply-extend-send-img {
		background-color: #007ddb;
	}
	.reply-extend-history {
		height: 0;
		flex-grow: 1;
		overflow-x: hidden;
		overflow-y: auto;
		border-top: 1px solid #dedede;
	}
	.reply-extend-history-wrap{
		padding: 0 26px;
	}
	.reply-extend-item{
		margin-top: 10px;
		border: 1px solid #dedede;
		border-radius: 4px;
	}
	.reply-extend-link{
		width: 100%;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
		line-height: 20px;
	}
	.reply-extend-link .reply-extend-link-title{
		max-height: 40px;
		overflow: hidden;
		font-weight: 600;
		word-wrap: break-word;
		text-overflow: ellipsis;
		padding: 5px 5px 0 5px;
	}
	.reply-extend-link .reply-extend-link-info{
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		align-items: center;
		padding: 0 5px;
	}
	.reply-extend-link-info p{
		flex-grow: 1;
		width: 0;
		max-height: 60px;
		overflow: hidden;
		font-size: 12px;
		color: #a6a6a6;
	}
	.reply-extend-link-info img{
		width: 40px;
		height: 40px;
		margin-left: 10px;
	}
	.reply-extend-link .reply-extend-link-tip{
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
		align-items: center;
		border-top: 1px solid #dedede;
		margin: 0 5px;
	}
	.reply-extend-link-tip img{
		height: 16px;
		width: auto;
		margin-right: 5px;
	}
	.reply-extend-link-tip p{
		color: #999999;
		font-size: 12px;
		line-height: 22px;
	}
	.reply-extend-link .reply-extend-link-tip-noborder{
		border-top: none;
	}
	.reply-extend-link-tip-noborder > img{
		height: 14px;
	}
	.reply-extend-img{
		width: 100%;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
		line-height: 20px;
	}
	.reply-extend-img-box{
		min-height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.reply-extend-img-box > img{
		width: auto;
		max-width: 100%;
		height: auto;
	}
	.reply-extend-img-tip{
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
		align-items: center;
		border-top: 1px solid #dedede;
		margin: 0 5px;
	}
	.reply-extend-img-tip img{
		height: 14px;
		width: auto;
		margin-right: 5px;
	}
	.reply-extend-img-tip p{
		color: #999999;
		font-size: 12px;
		line-height: 22px;
	}
	.reply-extend-img-tip .reply-extend-img-pass{
		color: #2bad37;
	}
	.reply-extend-count{
		line-height: 30px;
		text-align: center;
		color: #666666;
		font-size: 12px;
	}
</style>
